<template>
  <div class="authData">
    <div style="height:92px; width: 400px">
      <el-input v-model="selectTotal" placeholder="请输入内容" style="margin-bottom: 10px"></el-input>
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    </div>
    <div :class="readonly ? 'treestyle' : 'treestyle1'" v-loading="loading">
      <el-tree class="filter-tree" :data="menuData" :props="defaultProps" show-checkbox node-key="id" highlight-current
        default-expand-all :default-checked-keys="menuCheckedList" :filter-node-method="filterNode"
        @check-change="clickDeal" ref="tree">
      </el-tree>
    </div>
    <div class="footer" v-show="authDatasEditFlag">
      <rs-button @click="authDatasCencel">取消</rs-button>
      <rs-button type="primary" @click="authDatasSubmitAuth">保存</rs-button>
    </div>
  </div>
</template>

<script>
import userApi from "@/api/api";
export default {
  props: {
    type: {
      type: String,
      default: "role",
    },
    userId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      menuCheckedList: [],
      filterText: "",
      loading: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      menuData: [],
      readonly: true,
      menuDataSelect: [],
      authDatasEditFlag: false,
    };
  },
  computed: {
    selectTotal() {
      return `已选择${this.menuCheckedList.length}项`;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 角色新增时没有operationId，请求所有菜单按钮资源
    handleAllResource() {
      this.loading = true;
      let params = {
        userId: this.userId,
        // userId: 1153,
      };
      userApi.listNewTreemallManage(params).then((res) => {
        this.menuData = [];
        this.menuDataSelect = [];
        this.menuCheckedList = []
        res.data.data.forEach((item) => {
          this.menuData.push(this.handleMenu(item));
        });
        this.loading = false;
      });
    },
    // 菜单树形处理
    handleMenu(el) {
      this.menuDataSelect.push(el);
      if (el.type == 1) {
        if (this.menuCheckedList.indexOf(el.id) == -1) {
          this.menuCheckedList.push(el.id);
        }
      }

      console.log(this.menuCheckedList);
      const haveChildren = Array.isArray(el.children);
      return {
        disabled: this.readonly,
        checked: el.type == 1 ? true : false,
        label: `${el.tierName}`,
        id: el.id,
        value: `${el.relId}`,
        parentId: `${el.parentId}`,
        children: { ...el },
        children: haveChildren
          ? el.children.map((i) => this.handleMenu(i))
          : null,
      };
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    clickDeal(datas, checkeds) {
      if (checkeds) {
        this.menuCheckedList.push(datas.id);
      } else {
        let index = this.menuCheckedList.indexOf(datas.id);
        if (index != -1) {
          this.menuCheckedList.splice(index, 1);
        }
      }
    },
    //修改数据权限
    changeReadonly(falag) {
      this.readonly = falag;
      this.authDatasEditFlag = !falag;
      this.handleAllResource();
    },
    // 数据权限取消
    authDatasCencel() {
      this.changeReadonly(true);
      this.menuCheckedList = []
    },
    // 数据权限保存
    authDatasSubmitAuth() {
      let arr = this.menuDataSelect.filter((item) => {
        return this.menuCheckedList.indexOf(item.id) > -1;
      });

      let params = {
        privilegeVoList: arr.map((item) => {
          let obj = {
            masterId: this.userId,
            accessId: item.relId,
            accessType: item.tierLevel == 4 ? 2 : 3,
            operationType: 2,
            masterType: 1,
          };
          //      "masterId": 1152,  用户userId
          // "accessId": 5,     取对应的relId
          // "accessType": 2,   2 表示项目级别（即tierLevel = 4），3表示其他级别（即tierLevel！=4）
          // "operationType": 2,2 表示勾选，3表示取消勾选
          // "masterType":1 默认1

          return obj;
        }),
        operationId: this.userId,
        operationType: 0,
        type: 0,
      };
      userApi.addPrivilegeprivilege(params).then((res) => {
        this.$message.success("保存成功！");
        this.authDatasCencel();
      });
    },
  },
  created() {
    this.handleAllResource();
  },
};
</script>

<style lang="less" scoped>
.treestyle {
  max-height: calc(100vh - 223px);
  overflow-y: auto;
}

.treestyle1 {
  max-height: calc(100vh - 273px);
  overflow-y: auto;
}

.treestyle::-webkit-scrollbar,
.treestyle1::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.footer {
  position: fixed;
  /* right: 5%; */
  bottom: 20px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #ccc;
  background: #fff;
  display: flex;
  bottom: 0;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  z-index: 99;
}
</style>
